import {register} from '../vendor/theme-scripts/theme-sections';
import {accordion} from '../features/accordion';
import collectionFiltersForm from '../features/collection-filters-form';
import {RadioSwatch, swatchGridSection} from '../features/swatch';
import {ProductGridItem} from '../features/product-grid-item';
import {ProductGridItemVariant} from '../features/product-grid-item-variant';
import {ProductGridItemImage} from '../features/product-grid-item-image';
import {PopoutSelect} from '../features/popout';
import {collectionFiltersSidebar} from '../features/collection-filters-sidebar';

register('search-page', [collectionFiltersSidebar, collectionFiltersForm, swatchGridSection, accordion]);

if (!customElements.get('popout-select')) {
  customElements.define('popout-select', PopoutSelect);
}

if (!customElements.get('radio-swatch')) {
  customElements.define('radio-swatch', RadioSwatch);
}

if (!customElements.get('product-grid-item')) {
  customElements.define('product-grid-item', ProductGridItem);
}

if (!customElements.get('product-grid-item-variant')) {
  customElements.define('product-grid-item-variant', ProductGridItemVariant);
}

if (!customElements.get('product-grid-item-image')) {
  customElements.define('product-grid-item-image', ProductGridItemImage);
}
